var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNoImage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M45 5.121L42.879 3L3 42.879L5.121 45L8.121 42H39C39.7953 41.9988 40.5577 41.6824 41.12 41.12C41.6824 40.5577 41.9988 39.7953 42 39V8.121L45 5.121ZM39 39H11.121L22.8105 27.3105L26.379 30.879C26.9416 31.4414 27.7045 31.7574 28.5 31.7574C29.2955 31.7574 30.0584 31.4414 30.621 30.879L33 28.5L39 34.4955V39ZM39 30.252L35.121 26.373C34.5584 25.8106 33.7955 25.4946 33 25.4946C32.2045 25.4946 31.4416 25.8106 30.879 26.373L28.5 28.752L24.9345 25.1865L39 11.121V30.252ZM9 33V28.5L16.5 21.0045L18.5595 23.0655L20.6835 20.9415L18.621 18.879C18.0584 18.3166 17.2955 18.0006 16.5 18.0006C15.7045 18.0006 14.9416 18.3166 14.379 18.879L9 24.258V9H33V6H9C8.20435 6 7.44129 6.31607 6.87868 6.87868C6.31607 7.44129 6 8.20435 6 9V33H9Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoImage);
export default __webpack_public_path__ + "static/media/no-image.3705cd4fdba29fb1473d11bede9cddd2.svg";
export { ForwardRef as ReactComponent };